import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging } from 'firebase/messaging';

// Firebase configuration for contact.aurixinfo@gmail.com
const firebaseConfig = {
  apiKey: "AIzaSyCJdv4WgG0hSEP4KyG1byoqJUeRC2nDAGM",
  authDomain: "aurixstaff.firebaseapp.com",
  projectId: "aurixstaff",
  storageBucket: "aurixstaff.firebasestorage.app",
  messagingSenderId: "494408294181",
  appId: "1:494408294181:web:aeef06440fa44f8e5504cc",
  measurementId: "G-TDCVWQ0ZM2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Initialize messaging (only in browser, not in service worker)
let messaging = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.log('Messaging not available:', error);
  }
}
export { messaging };

